import {AppErrorStatusCode} from 'common/constants';
import UILogger from 'common/utils/logger';

export class AppStateController {
  public static instance: AppStateController;
  private serverTimestampDelta: number = 0;
  private internetActive: boolean | undefined = undefined;
  
  private appHttpErrorListeners: Array<{
    name: string;
    callback: (errorCode: AppErrorStatusCode) => void;
  }> | null = null;

  private constructor() {
    this.registerAppStateEvents();
  }

  public static getInstance() {
    if (!AppStateController.instance) {
      AppStateController.instance = new AppStateController();
    }
    return AppStateController.instance;
  }

  

  registerAppStateEvents() {
    // new NativeEventEmitter().addListener(
    //   APP_EVENT,
    //   (event: any) => {
    //     UILogger.log('App event: received: ', event);
    //     if (event && event.action) {
    //       if (AppEventType.AppInBackground === event.action) {
    //         this.appStateStatus = 'appInBackground';
    //       } else if (AppEventType.AppInForeground === event.action) {
    //         this.appStateStatus = 'appInForeground';
    //       }
    //     }
    //     UILogger.log('App event: setting appStatus: ', this.appStateStatus);
    //   },
    //   this,
    // );
  }


  public subscribeAppError(
    name: string,
    callback: (code: AppErrorStatusCode) => void,
  ) {
    if (this.appHttpErrorListeners == null) {
      this.appHttpErrorListeners = [];
    } else {
      const findIndex = this.appHttpErrorListeners.findIndex(
        clbk => clbk.name === name,
      );
      if (findIndex >= 0) {
        this.appHttpErrorListeners.splice(findIndex, 1);
      }
    }
    const pushed = this.appHttpErrorListeners.push({
      name,
      callback,
    });

    UILogger.log(
      'total AppErrorListeners:',
      this.appHttpErrorListeners,
      'pushed',
      pushed,
    );
  }

  removeAppErrorListener(name: string) {
    UILogger.log('Removing appHttpErrorListeners: ', name);
    if (
      this.appHttpErrorListeners != null &&
      this.appHttpErrorListeners.length > 0
    ) {
      const findIndex = this.appHttpErrorListeners.findIndex(
        clbk => clbk.name === name,
      );
      if (findIndex >= 0) {
        this.appHttpErrorListeners.splice(findIndex, 1);
      }
    }
  }

  public updateAppErrorListeners(statusCode: AppErrorStatusCode) {
    UILogger.log(
      'Current AppErrorListeners: statusCode received',
      statusCode,
      'total listeners:',
      this.appHttpErrorListeners,
    );
    if (
      this.appHttpErrorListeners != null &&
      this.appHttpErrorListeners.length > 0
    ) {
      this.appHttpErrorListeners.forEach(gsr => {
        if (gsr.callback) {
          gsr.callback(statusCode);
        }
      });
    }
  }

  public setServerTimeDeltaInMillis(serverTimeDelta: number) {
    UILogger.log('Setting server time delta: ' + serverTimeDelta);
    this.serverTimestampDelta = serverTimeDelta;
  }
  public getServerTimeDeltaInMillis() {
    return this.serverTimestampDelta;
  }

  public setInternetActive(isActive: boolean) {
    this.internetActive = isActive;
  }
  public IsInternetActive() {
    return this.internetActive;
  }
}
